import React from 'react'
import { RouterSwitchCP } from 'submodules/nerit-framework-ui/common/router/components/router-switch/RouterSwitchCP'
import { ScreenError404 } from 'submodules/nerit-framework-ui/common/screens/ScreenError404'
import { ScreenHome } from 'app/screens/screen-home/ScreenHome'
import { ScreenDataAnalisys } from 'modules/reports/screens/screen-data-analysis/ScreenDataAnalisys'
import { ScreenUsers } from 'modules/users/screens/screen-users/ScreenUsers'
import { ScreenLocations } from 'modules/locations/screens/screen-locations/ScreenLocations'
import { ScreenSamplings } from 'modules/samplings/screens/screen-samplings/ScreenSamplings'
import { ScreenFieldRegulation } from 'modules/fields/screens/screen-fields-regulation/ScreenFieldRegulation'
import { ScreenMap } from 'modules/map/screens/screen-map/ScreenMap'
import { ScreenDevTest } from 'app/screens/screen-dev/ScreenDevTest'
import { ScreenCharts } from 'modules/reports/screens/screen-charts/ScreenCharts'
import { ScreenRegulation } from 'modules/fields/screens/screen-regulation/ScreenRegulation'
import { ScreenSamplingImport } from 'modules/samplings/screens/screen-sampling-import/ScreenSamplingImport'
import { ScreenFields } from 'modules/fields/screens/screen-fields/ScreenFields'
import { ScreenQAQC } from 'modules/reports/screens/screen-qaqc/ScreenQAQC'
import { ScreenCollectionPerformanceAdmin } from 'modules/collection-performance/screens/screen-collection-performance-admin/ScreenCollectionPerformanceAdmin'
import { ScreenCollectionControl } from 'modules/collection-performance/screens/screen-collection-control/ScreenCollectionControl'
import { ScreenParameterControl } from 'modules/collection-performance/screens/screen-parameter-control/ScreenParameterControl'

PrivateRouter.ROOT = 'private'

PrivateRouter.HOME = `${PrivateRouter.ROOT}/home`
PrivateRouter.MAP = `${PrivateRouter.ROOT}/map`

PrivateRouter.DATA_ANALISYS = `${PrivateRouter.ROOT}/data-analisys`

PrivateRouter.REPORT = `${PrivateRouter.ROOT}/report`
PrivateRouter.RADA_REPORT = `${PrivateRouter.ROOT}/rada_report`
PrivateRouter.IMPORT = `${PrivateRouter.ROOT}/import`

PrivateRouter.PROFILE = `${PrivateRouter.ROOT}/profile`
PrivateRouter.FIELD_VALUES = `${PrivateRouter.ROOT}/field-values`
PrivateRouter.EXPORT = `${PrivateRouter.ROOT}/export`

PrivateRouter.USERS = `${PrivateRouter.ROOT}/users`
PrivateRouter.LOCATIONS = `${PrivateRouter.ROOT}/locations`
PrivateRouter.SAMPLINGS = `${PrivateRouter.ROOT}/samplings`
PrivateRouter.FIELDS = `${PrivateRouter.ROOT}/fields`
PrivateRouter.FIELD_CONFIG = `${PrivateRouter.ROOT}/field-config`
PrivateRouter.REGULATIONS = `${PrivateRouter.ROOT}/regulations`

PrivateRouter.CHARTS = `${PrivateRouter.ROOT}/charts`
PrivateRouter.CHART_HISTORIC_SERIES = `${PrivateRouter.CHARTS}/historic-series`
PrivateRouter.CHART_STATISTIC = `${PrivateRouter.CHARTS}/statistic`
PrivateRouter.CORRELATION_FIELDS = `${PrivateRouter.CHARTS}/correlation-fields`
PrivateRouter.CORRELATION_LOCATIONS = `${PrivateRouter.CHARTS}/correlation-locations`
PrivateRouter.CORRELATION_MATRIX = `${PrivateRouter.CHARTS}/correlation-matrix`
PrivateRouter.GEOGRAPHIC = `${PrivateRouter.CHARTS}/geographic`
PrivateRouter.WATER_CONTAMINATION = `${PrivateRouter.CHARTS}/water-contamination`
PrivateRouter.WATER_QUALITY = `${PrivateRouter.CHARTS}/water-quality`
PrivateRouter.IET = `${PrivateRouter.CHARTS}/iet`
PrivateRouter.QAQC = `${PrivateRouter.ROOT}/qaqc`
PrivateRouter.QAQC_IONIC_BALANCE_HISTORY = `${PrivateRouter.QAQC}/ionic-balance-history`
PrivateRouter.QAQC_ANOMALY_EVALUATION_HISTORY = `${PrivateRouter.QAQC}/anomaly-evaluation-history`
PrivateRouter.NON_CONFORMITY = `${PrivateRouter.CHARTS}/non-conformity`

PrivateRouter.COLLECTION_PERFORMANCE = `${PrivateRouter.ROOT}/collection-performance`
PrivateRouter.COLLECTION_PERFORMANCE_ADMIN = `${PrivateRouter.COLLECTION_PERFORMANCE}/admin`
PrivateRouter.COLLECTION_CONTROL = `${PrivateRouter.COLLECTION_PERFORMANCE}/collection`
PrivateRouter.PARAMETER_CONTROL = `${PrivateRouter.COLLECTION_PERFORMANCE}/parameter`

PrivateRouter.DEV_TEST = `${PrivateRouter.ROOT}/dev-test`

/**
 * Define rotas que so podem ser acessadas apos realizar login.
 */
export function PrivateRouter(): JSX.Element {

    return (
        <RouterSwitchCP
            routes={[
                { path: PrivateRouter.HOME, component: ScreenHome },
                { path: PrivateRouter.USERS, component: ScreenUsers },
                { path: PrivateRouter.LOCATIONS, component: ScreenLocations },
                { path: PrivateRouter.SAMPLINGS, component: ScreenSamplings },
                { path: PrivateRouter.FIELDS, component: ScreenFields },
                { path: PrivateRouter.FIELD_CONFIG, component: ScreenFieldRegulation },
                { path: PrivateRouter.REGULATIONS, component: ScreenRegulation },

                { path: PrivateRouter.DATA_ANALISYS, component: ScreenDataAnalisys },

                { path: PrivateRouter.QAQC, component: ScreenQAQC },
                { path: PrivateRouter.QAQC_IONIC_BALANCE_HISTORY, component: ScreenQAQC },
                { path: PrivateRouter.QAQC_ANOMALY_EVALUATION_HISTORY, component: ScreenQAQC },

                { path: PrivateRouter.IMPORT, component: ScreenSamplingImport },
                { path: PrivateRouter.EXPORT, component: (): JSX.Element => { return <>Exportar dados</> } },

                { path: PrivateRouter.CHARTS, component: ScreenCharts },

                { path: PrivateRouter.COLLECTION_PERFORMANCE_ADMIN, component: ScreenCollectionPerformanceAdmin },
                { path: PrivateRouter.COLLECTION_CONTROL, component: ScreenCollectionControl },
                { path: PrivateRouter.PARAMETER_CONTROL, component: ScreenParameterControl },

                { path: PrivateRouter.MAP, component: ScreenMap },
                { path: PrivateRouter.REPORT, component: (): JSX.Element => { return <>Relatório</> } },
                { path: PrivateRouter.RADA_REPORT, component: (): JSX.Element => { return <>Relatório Rada</> } },
                { path: PrivateRouter.PROFILE, component: (): JSX.Element => { return <>Perfil</> } },

                { path: `${PrivateRouter.DEV_TEST}`, component: ScreenDevTest, },
                { component: () => <ScreenError404 redirectTo={PrivateRouter.HOME}/> },
            ]}
        />
    )
}
